module.exports = __webpack_public_path__ + "static/media/student portal manager.5a0520f3.svg";